"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var UseNotificationSettings_1 = require("./UseNotificationSettings");
var NumberInput_1 = __importDefault(require("@CommonFrontend/NumberInput/NumberInput"));
var styles = __importStar(require("./Notifications.css"));
var angularTemplate = require("./AngularToReactMount.html");
var AngularController = (function () {
    function AngularController(createUi, user, mountReactComponent) {
        this.ui = createUi(angularTemplate, {
            reactUi: mountReactComponent(react_1.default.createElement(NotificationSettings, { userId: user._id })),
        });
    }
    return AngularController;
}());
exports.default = AngularController;
var NotificationSettings = function (_a) {
    var userId = _a.userId;
    var _b = (0, UseNotificationSettings_1.useNotificationSettings)(userId), notificationSettings = _b.notificationSettings, updater = _b.updater;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.wrapper, align: "center" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.content, gap: "l" },
            react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", gap: "xs" },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.framedNotificationIcon, align: "center", justify: "center" },
                    react_1.default.createElement(icons_1.Notifications, null)),
                react_1.default.createElement(kaleidoscope_1.Label, { size: "l" }, "Notifications"),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" },
                    "Choose which notifications you will receive. For more information visit the",
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/155-notifications" }, " notifications help docs."))),
            notificationSettings ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SettingsSection, { initialSettings: notificationSettings, updater: updater }))) : (react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true })))));
};
var SettingsSection = function (_a) {
    var initialSettings = _a.initialSettings, updater = _a.updater;
    var _b = __read((0, react_1.useState)(function () { return initialSettings; }), 2), settingsState = _b[0], setSettingsState = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), updateError = _c[0], setUpdateError = _c[1];
    var areSettingsUnchanged = (0, isEqual_1.default)(settingsState, initialSettings);
    function setPageViewsSelection(newSelection) {
        if (settingsState.pageViewsSelection === newSelection)
            return;
        var pageViewsCustomNumber = newSelection === "custom" ? 2 : null;
        setSettingsState(__assign(__assign({}, settingsState), { pageViewsCustomNumber: pageViewsCustomNumber, pageViewsSelection: newSelection }));
    }
    function setPageViewsCustomNumber(newValue) {
        var integerValue = Math.floor(newValue);
        setSettingsState(__assign(__assign({}, settingsState), { pageViewsCustomNumber: integerValue }));
    }
    function onUpdateClick() {
        return __awaiter(this, void 0, Promise, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setUpdateError(null);
                        return [4, updater(settingsState)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        setUpdateError(e_1);
                        throw e_1;
                    case 3: return [2];
                }
            });
        });
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l", align: "center" },
        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { className: styles.pagesLevelControl, label: "Pages", options: [
                { label: "Everyone's pages", value: "everyones" },
                { label: "Only your pages", value: "yours" },
            ], selectedValue: settingsState.level, onClickHandler: function (newValue) { return setSettingsState(__assign(__assign({}, settingsState), { level: newValue })); }, size: kaleidoscope_1.SegmentedControlSize.Large }),
        react_1.default.createElement(ToggleCard, { label: "Comments", value: settingsState.commentsEnabled, description: "Receive notifications when comments are added or resolved", onChange: function (isActive) { return setSettingsState(__assign(__assign({}, settingsState), { commentsEnabled: isActive })); } }),
        react_1.default.createElement(ToggleCard, { label: "Page views", value: settingsState.pageViewsEnabled, onChange: function (isActive) { return setSettingsState(__assign(__assign({}, settingsState), { pageViewsEnabled: isActive })); }, description: "Receive notifications when a page is viewed" },
            react_1.default.createElement(kaleidoscope_1.Expandable, { className: styles.pageViewsExpandable, expanded: settingsState.pageViewsEnabled }, function (_a) {
                var expandableElementRef = _a.expandableElementRef;
                return (react_1.default.createElement(kaleidoscope_1.Stack, { ref: expandableElementRef, gap: "xs" },
                    react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Page views selection", labelHidden: true, options: [
                            { label: "Every view", value: "every" },
                            { label: "First view", value: "first" },
                            { label: "Custom", value: "custom" },
                        ], selectedValue: settingsState.pageViewsSelection, onClickHandler: setPageViewsSelection }),
                    react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: settingsState.pageViewsSelection === "custom" }, function (_a) {
                        var expandableElementRef = _a.expandableElementRef;
                        return (react_1.default.createElement(kaleidoscope_1.Stack, { ref: expandableElementRef, direction: "horizontal", gap: "xxs", align: "center" },
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "For the first"),
                            react_1.default.createElement("div", { className: styles.pageViewCountInput },
                                react_1.default.createElement(NumberInput_1.default, { label: "Page view count", labelHidden: true, showStepper: true, value: settingsState.pageViewsCustomNumber, min: 1, type: kaleidoscope_1.TextInputType.Number, variant: kaleidoscope_1.TextInputVariant.Underlined, size: kaleidoscope_1.TextInputSize.Small, inputMode: "numeric", onChange: setPageViewsCustomNumber })),
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "views on each page")));
                    })));
            })),
        react_1.default.createElement(ToggleCard, { label: "Engagement", description: "Receive notifications when a page changes engagement levels", value: settingsState.engagement, onChange: function (isActive) { return setSettingsState(__assign(__assign({}, settingsState), { engagement: isActive })); } }),
        react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Large, disabled: areSettingsUnchanged, onClick: onUpdateClick }, "Update notifications"),
        !!updateError && (react_1.default.createElement(kaleidoscope_1.Alert, { className: styles.updateErrorAlert, heading: "Oh no!", alertType: kaleidoscope_1.AlertType.Error }, "Your changes were unable to be saved. Please re-save, or try again later."))));
};
var ToggleCard = function (_a) {
    var label = _a.label, description = _a.description, value = _a.value, onChange = _a.onChange, children = _a.children;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: styles.toggleCard },
        react_1.default.createElement(kaleidoscope_1.Stack, { align: "start" },
            react_1.default.createElement(kaleidoscope_1.Toggle, { label: label, value: value, onChange: onChange }),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, description),
            children)));
};
